import { render, staticRenderFns } from "./OrganizationServiceAccessDropdowns.vue?vue&type=template&id=098bc0da&scoped=true&"
import script from "./OrganizationServiceAccessDropdowns.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrganizationServiceAccessDropdowns.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OrganizationServiceAccessDropdowns.vue?vue&type=style&index=0&id=098bc0da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bc0da",
  null
  
)

export default component.exports